import { _Componentes_WebApiCalls_Post, _Componentes_WebApiCalls_PostBlob } from "../ComponentesGlobales/WebApiCalls";

export const obtenerFacturasHistorial = (request, opciones) =>
  _Componentes_WebApiCalls_Post("PISeunComprobantes/Facturas", request, opciones);

export const obtenerFacturaHistorial = ({ EmpresaId, FacturaId }, opciones) =>
  _Componentes_WebApiCalls_Post("PISeunComprobantes/Factura", { EmpresaId, FacturaId: Number(FacturaId) }, opciones);

export const obtenerRemitosHistorial = (request, opciones) =>
  _Componentes_WebApiCalls_Post("PISeunComprobantes/Remitos", request, opciones);

export const obtenerRemitoHistorial = ({ EmpresaId, RemitoId }, opciones) =>
  _Componentes_WebApiCalls_Post("PISeunComprobantes/Remito", { EmpresaId, RemitoId: Number(RemitoId) }, opciones);

export const descargarFacturaHistorial = ({ EmpresaId, FacturaId }) =>
  _Componentes_WebApiCalls_PostBlob("Facturacion078/ComprobantePdf", {
    EmpresaId, FacturaId: Number(FacturaId), Copia: "ORIGINAL",
  });
